import React from 'react'
import { ComponentStory } from '@storybook/react'
import moment from 'moment'
import DatepickerComponent from '../fields/Datepicker'
import { FieldSize } from '../components/FieldStyles'

export default {
  title: 'Fields/Datepicker',
  component: DatepickerComponent,
}

const DatepickerTemplate: ComponentStory<typeof DatepickerComponent> = (
  args,
) => <DatepickerComponent {...args} />

export const Datepicker = DatepickerTemplate.bind({})
Datepicker.args = {
  maxDate: moment('01-12-2022', 'DD-MM-YYYY'),
  futureOnly: true,
  customColor: 'red',
  fieldSize: FieldSize.Large,
}
